import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  requiredRole: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRole }) => {
  const { isAuthenticated, hasRole } = useAuth();

  const redirectPath = requiredRole === 'ADMIN' ? '/manage' : '/login';

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  if (!hasRole(requiredRole)) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
